import { ThirdPartyAppConfigurationCommand } from '@api/index';
import { AssetInfo } from './models/asset-info';

export class GetConfiguration {
    public static readonly type = '[Pressure] Get Configuration';

    constructor(public appName: string) {}
}

export class SaveConfiguration {
    public static readonly type = '[Pressure] Save Configuration';

    constructor(public configuration: ThirdPartyAppConfigurationCommand) {}
}

export class SetSelectedAsset {
    public static readonly type = '[Pressure] Set Selected Asset';

    constructor(public selectedAsset: AssetInfo) {}
}

export class SetConfiguration {
    public static readonly type = '[Pressure] Set Configuration';

    constructor(public configuration: string) {}
}

export class GetPressureSensors {
    public static readonly type = '[Pressure] Get Pressure Sensors';
}
